/*
 * Model for typeahead request and defines all the reqres' for obtaining typeahead results
 */

define([
  "backbone",
  "configuration/properties",
  "messaging/messenger",
  "modules/topicsSplit/topics/topicSearch/topicSearchModel",
], function (Backbone, Properties, Messenger) {
  var TypeaheadModel = {};

  const topicTypes = Messenger.reqres.request("get:topicTypes");
  TypeaheadModel.typeaheadResults = Backbone.Model.extend({
    getResultsArray: function () {
      return this.get("results");
    },
  });

  TypeaheadModel.typeaheadIdResult = Backbone.Model.extend({
    defaults: {
      id: 0,
      text: "",
    },
  });

  TypeaheadModel.typeaheadIdResults = Backbone.Collection.extend({
    model: TypeaheadModel.typeaheadIdResult,
  });

  Messenger.reqres.setHandler(
    "substitutions:typeahead",
    function (query, topicType) {
      if (!topicType) topicType = topicTypes.NON_ARCHIVED;
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/substitutions/topicType/${topicType}/search` +
          `?groupName=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "substitution:entries:typeahead",
    function (query) {
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/substitutions/entries/search` +
          `?subgroupEntryName=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "topics:typeahead",
    function (query, topicType) {
      if (!topicType) topicType = topicTypes.NON_ARCHIVED;
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/intents/topicType/${topicType}/search` +
          `?name=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler("topicsWithId:typeahead", (query) => {
    const results = new TypeaheadModel.typeaheadIdResults();
    results.url = () => {
      const kbId = Messenger.reqres.request("active:kb");
      return (
        `${Properties.rootURL}/${kbId}/` +
        `typeahead/intentsWithId/search` +
        `?name=${encodeURIComponent(query)}`
      );
    };
    results.fetch();
    return results;
  });

  Messenger.reqres.setHandler(
    "topic:examples:typeahead",
    function (query, localeId, topicType) {
      if (!localeId) localeId = -1;
      if (!topicType) topicType = topicTypes.NON_ARCHIVED;
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/intents/examples/` +
          `locale/${localeId}/` +
          `topicType/${topicType}/search` +
          `?exampleText=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "topic:labels:typeahead",
    function (query, localeId, topicType) {
      if (!topicType) topicType = topicTypes.NON_ARCHIVED;
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/intents/` +
          `locale/${localeId}/` +
          `topicType/${topicType}/search` +
          `?label=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "decisions:typeahead",
    function (query, topicType) {
      if (!topicType) topicType = topicTypes.NON_ARCHIVED;
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/intents/decisions/` +
          `topicType/${topicType}/search` +
          `?name=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "snippets:typeahead",
    ({ blockId, languageId, query, touchpointId }) => {
      const results = new TypeaheadModel.typeaheadIdResults();
      results.url = function () {
        const kbId = Messenger.reqres.request("active:kb");
        let url =
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/snippets/search` +
          `?name=${encodeURIComponent(query)}`;
        if (blockId) {
          url += `&blockId=${blockId}`;
        }
        if (languageId) {
          url += `&languageId=${languageId}`;
        }
        if (touchpointId) {
          url += `&touchpointId=${touchpointId}`;
        }
        return url;
      };
      results.fetch();
      return results;
    },
  );

  Messenger.reqres.setHandler(
    "contents:typeahead",
    function (query, topicType) {
      if (!topicType) topicType = topicTypes.NON_ARCHIVED;
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/mappings/search` +
          `?name=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "contents:typeahead:topicType",
    function (query, topicType) {
      if (!topicType) topicType = topicTypes.NON_ARCHIVED;
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/` +
          `topicType/${topicType}/mappings/search` +
          `?name=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "content:urls:typeahead",
    function (query) {
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/mappings/urls/search` +
          `?url=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "users:typeahead",
    function (query) {
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/users/search?username=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "usersWithId:typeahead",
    function (query) {
      var results = new TypeaheadModel.typeaheadIdResults();
      var kbId = Messenger.reqres.request("active:kb");
      results.url =
        `${Properties.rootURL}/${kbId}/` +
        `typeahead/usersWithId/search` +
        `?username=${encodeURIComponent(query)}`;
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "kb:availableLanguages:typeahead",
    function (query, kbId) {
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/languages/available/search` +
          `?name=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "language:all:typeahead",
    function (query) {
      var results = new TypeaheadModel.typeaheadResults();
      results.url = function () {
        return `${Properties.rootURL}/typeahead/languages/search?name=${encodeURIComponent(query)}`;
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "attributes:all:typeahead",
    function (query) {
      var results = new TypeaheadModel.typeaheadResults();
      var kbId = Messenger.reqres.request("active:kb");
      results.url = function () {
        return (
          `${Properties.rootURL}/${kbId}/` +
          `typeahead/attributes/search` +
          `?name=${encodeURIComponent(query)}`
        );
      };
      results.fetch();
      return results;
    },
    this,
  );

  Messenger.reqres.setHandler("departments:typeahead", function (query) {
    var results = new TypeaheadModel.typeaheadIdResults();
    var kbId = Messenger.reqres.request("active:kb");
    results.url =
      `${Properties.rootURL}/${kbId}/` +
      `typeahead/departments/search` +
      `?name=${encodeURIComponent(query)}`;
    results.fetch();
    return results;
  });

  Messenger.reqres.setHandler("tasks:typeahead", function (query) {
    var results = new TypeaheadModel.typeaheadIdResults();
    var kbId = Messenger.reqres.request("active:kb");
    results.url =
      `${Properties.rootURL}/${kbId}/` +
      `typeahead/tasks/search` +
      `?name=${encodeURIComponent(query)}`;
    results.fetch();
    return results;
  });
});
